module.exports = __webpack_public_path__ + "static/media/carousel9.221df12b.jpeg";